<template>
  <header class="hm1" :class="{ 'menu-open': mobileMenuOpen }">
    <a href="/"><v-img class="logo" :src="require('../assets/logo2.png')" /></a>
    <button class="mobile-nav-toggle" type="button" :aria-expanded="mobileMenuOpen ? 'true' : 'false'" aria-label="Toggle navigation menu" @click="toggleMobileMenu">
      <span></span>
      <span></span>
      <span></span>
    </button>
    <nav class="navbar">
      <a class="button" href="/" id="nav_/" @click="closeMobileMenu">Home</a>
      <a class="button" href="/about" id="nav_/about" @click="closeMobileMenu">About</a>
      <a class="button" href="/services" id="nav_/services" @click="closeMobileMenu">Services</a>
      <a class="button" href="/contact" id="nav_/contact" @click="closeMobileMenu">Contact</a>
    </nav>
  </header>
  <section class="csec1">
    <p class="title">Contact Us</p>
    <p class="subtitle">Reach out to RDS Corp directly for software consulting, custom development, product partnerships, or general business inquiries.</p>
    <div class="contact-grid">
      <div class="contact-card">
        <p class="card-label">Email</p>
        <a class="card-value linkable" href="mailto:support@rajputanards.com">support@rajputanards.com</a>
        <p class="card-copy">Best for project discussions, partnership conversations, and detailed business inquiries.</p>
      </div>
      <div class="contact-card">
        <p class="card-label">Phone</p>
        <a class="card-value linkable" href="tel:+918696969966">+91 8696969966</a>
        <p class="card-copy">Call for faster coordination on active opportunities, follow-ups, and direct support requests.</p>
      </div>
      <div class="contact-card wide">
        <p class="card-label">Address</p>
        <p class="card-value">3, Van Vihar Colony, Tonk Road, Jaipur-302015, Rajasthan, India</p>
        <p class="card-copy">RDS Corp operates from Jaipur and supports businesses across consulting, software delivery, and digital product execution.</p>
      </div>
    </div>
    <div class="cta-row">
      <a class="b1" href="mailto:support@rajputanards.com?subject=Inquiry%20for%20RDS%20Corp">Send Mail</a>
      <a class="b1 secondary" href="tel:+918696969966">Call Now</a>
    </div>
  </section>
  <footer class="fm1">
    <div class="d1">
      <div class="sd1">
        <v-img class="logo" :src="require('../assets/logo3.png')" />
      </div>
      <div class="sd2">
        <div class="s1">
          <p class="title">General</p>
          <a class="link n" href="/about">About Us</a>
          <a class="link n" href="/services">Services</a>
          <a class="link n" href="/contact">Contact Us</a>
          <p class="title">Products</p>
          <a class="link n" href="/zaqnet">Zaqnet</a>
          <a class="link n" href="/meridian">Meridian</a>
        </div>
        <div class="s1">
          <p class="title">Socials</p>
          <a class="link fb" href="https://www.facebook.com/rdscorp/" target="_blank"><span
              class="mdi mdi-facebook"></span> Facebook</a>
          <a class="link ig" href="https://www.instagram.com/rdscorpglobal/" target="_blank"><span
              class="mdi mdi-instagram"></span> Instagram</a>
          <a class="link x" href="https://www.x.com/rdscorpglobal/" target="_blank"><span class="mdi mdi-twitter"></span>
            Twitter</a>
          <a class="link ln" href="https://www.linkedin.com/company/rdscorp/" target="_blank"><span
              class="mdi mdi-linkedin"></span> LinkedIn</a>
        </div>
        <div class="s1">
          <p class="title">Terms & Policies</p>
          <a class="link n" href="/verify">Credential Verification</a>
          <a class="link n" href="/terms">Terms & Conditions</a>
          <a class="link n" href="/privacy">Privacy Policy</a>
        </div>
      </div>
    </div>
    <div class="d2">
      <p class="title">Copyright © 2026 RDS Corp. All rights reserved.</p>
    </div>
  </footer>
</template>
<script>
export default {
  name: "ContactUs",
  data: () => ({
    mobileMenuOpen: false
  }),
  mounted() {
    if (document.getElementById(`nav_${window.location.pathname}`)) {
      document
        .getElementById(`nav_${window.location.pathname}`)
        .classList.add("selected");
    }
  },
  methods: {
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen;
    },
    closeMobileMenu() {
      this.mobileMenuOpen = false;
    }
  }
};
</script>
<style lang="scss">
a {
  text-decoration: none;
  color: inherit;
}

.hm1 {
  width: 100%;
  height: 150px;
  background: linear-gradient(180deg, #fff 90%, transparent 100%);
  padding: 20px;
  padding-left: 150px;
  padding-right: 150px;
  padding-bottom: 0px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;

  .logo {
    height: 80px;
    width: 80px;
    flex-grow: 0;
    flex-shrink: 0;
  }

  nav {
    flex-grow: 0;
    flex-shrink: 0;
    display: flex;
    gap: 25px;

    .button {
      background-color: rgb(229, 229, 229);
      height: 40px;
      width: auto;
      border-radius: 1000px;
      font-size: 18px;
      padding-left: 20px;
      padding-right: 20px;
      display: grid;
      place-content: center;
    }

    .button:hover {
      outline: 2px solid #046fdb;
      outline-offset: 2px;
    }

    .button.selected {
      background-color: black;
      color: white;
    }
  }
}

.csec1 {
  padding-left: 150px;
  padding-right: 150px;
  margin-top: 250px;
  display: flex;
  flex-direction: column;
  padding-bottom: 100px;

  .title {
    font-family: fb;
    font-size: 55px;
  }

  .subtitle {
    font-family: fm;
    font-size: 35px;
    color: gray;
    max-width: 850px;
  }

  .b1 {
    padding: 10px;
    padding-left: 20px;
    padding-right: 20px;
    background-color: #0071e3;
    color: white;
    border-radius: 100px;
    font-size: 20px;
    margin-top: 40px;
    margin-bottom: 150px;
    cursor: pointer;
  }

  .b1:hover {
    opacity: 0.8;
  }

}
.b1.secondary {
  background-color: #111;
}
.contact-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 24px;
  margin-top: 50px;
}

.contact-card {
  border: 1px solid #e4e4e4;
  padding: 32px;
  background: #fff;
}

.contact-card.wide {
  grid-column: 1 / -1;
}

.card-label {
  font-family: fm;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #707070;
  font-size: 14px;
}

.card-value {
  margin-top: 14px;
  font-family: fb;
  font-size: 34px;
  line-height: 1.15;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.card-value.linkable:hover {
  text-decoration: underline;
}

.card-copy {
  margin-top: 14px;
  font-size: 18px;
  color: #666;
  max-width: 650px;
  overflow-wrap: anywhere;
}

.cta-row {
  display: flex;
  margin-top: 26px;
  gap: 16px;
  flex-wrap: wrap;
}
.fm1 {
  width: 100%;
  padding-left: 150px;
  padding-right: 150px;
  background-color: rgb(0, 0, 0);
  padding-top: 20px;

  .d1 {
    display: flex;
    justify-content: space-between;

    .sd1 {
      display: flex;
      flex-direction: column;

      .logo {
        width: 250px;
        height: 250px;
      }
    }

    .sd2 {
      display: flex;
      padding-top: 30px;
      gap: 50px;

      .s1 {
        display: flex;
        flex-direction: column;
        color: #fff;
        gap: 5px;

        .title {
          color: rgb(142, 142, 142);
          font-size: 17.5px;
        }

        .link {
          font-size: 20px;
          cursor: pointer;
        }

        .link.fb:hover {
          color: #1877f2;
        }

        .link.ig:hover {
          color: #fe0b81;
        }

        .link.x:hover {
          color: #1da1f2;
        }

        .link.ln:hover {
          color: #0077b5;
        }

        .link.n:hover {
          text-decoration: underline;
        }
      }
    }
  }

  .d2 {
    width: 100%;
    padding-bottom: 10px;
    padding-top: 10px;
    display: flex;

    .title {
      width: 100%;
      text-align: center;
      font-family: fl;
      color: white;
    }
  }
}

@media (max-width: 768px) and (orientation: portrait) {
  .hm1 {
    padding: 30px;
    height: 150px;

    .logo {
      width: 70px;
      height: 70px;
    }

    nav {
      display: none;
    }
  }

  .csec1 {
    padding-left: 30px;
    padding-right: 30px;
    .title {
      font-family: fm;
      font-size: 50px;
    }
  
    .subtitle {
      font-size: 30px;
      color: gray;
    }

    .b1 {
      font-size: 20px;
    }
  }

  .contact-grid {
    grid-template-columns: 1fr;
    gap: 18px;
    margin-top: 36px;
  }

  .contact-card {
    padding: 24px;
  }

  .card-value {
    font-size: 28px;
  }

  .card-copy {
    font-size: 17px;
  }

  .cta-row {
    margin-top: 22px;
    gap: 12px;
  }

  .fm1 {
    width: 100%;
    padding-left: 30px;
    padding-right: 30px;
    background-color: rgb(0, 0, 0);
    padding-top: 20px;

    .d1 {
      display: flex;
      flex-direction: column;

      .sd1 {
        display: flex;
        flex-direction: column;

        .logo {
          width: 200px;
          height: 200px;
        }
      }

      .sd2 {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        padding-top: 30px;
        gap: 50px;

        .s1 {
          display: flex;
          flex-direction: column;
          color: #fff;
          gap: 5px;

          .title {
            color: rgb(142, 142, 142);
            font-size: 17.5px;
          }

          .link {
            font-size: 20px;
            cursor: pointer;
          }

          .link.fb:hover {
            color: #1877f2;
          }

          .link.ig:hover {
            color: #fe0b81;
          }

          .link.x:hover {
            color: #1DA1F2;
          }

          .link.ln:hover {
            color: #0077b5;
          }

          .link.n:hover {
            text-decoration: underline;
          }
        }
      }
    }

    .d2 {
      width: 100%;
      padding-bottom: 10px;
      padding-top: 10px;
      display: flex;
      margin-top: 20px;
      padding-bottom: 20px;

      .title {
        width: 100%;
        text-align: center;
        font-family: fl;
        color: white;
      }
    }
  }
}

</style>
  
